import {Marker, Popup} from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster/src/react-leaflet-markercluster";
import LocatorList from "../StoresList/StoreLocatorList";

//import markers css
import './Markers.css'
import StoreListContainer from "../StoresList/StoreListContainer";
import DataHook from "../dataHook/dataHook";
import Searchbar from "../searchbar/searchbar";
import LoaderScreen from "../LoaderScreen/LoaderScreen";
import useStoresData from "../../hooks/useStoresData";
import Flaticon from "../flaticon/flaticon";

/**
 * Fetch all store from the WP api and add them on the leaflet map
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StoresMarker = (props) => {

    const stores = props.storesData
    const loading = props.isLoading

    /**
     * Return simple loader
     * @returns {JSX.Element}
     * @constructor
     */
    const LocatorListLoading = () => {
        return (
            <LoaderScreen/>
        )
    }

    return (
        <>
        { !loading ? <LocatorList settings={props.settings} storesList={stores} /> : <LocatorListLoading/> }
        <MarkerClusterGroup showCoverageOnHover={false} options={'LocationMarker'}>
            {stores.map((e,i) => {
                return (
                    e.sl_lat && e.sl_lng ?
                    <Marker type={"LocationMarker"} key={`StoreMarker-${i}`} position={[e.sl_lat,e.sl_lng]}>
                        <Popup className={'marker-popup'}>
                            <div onScroll={(e)=>{
                                if (e.currentTarget.scrollHeight <= e.currentTarget.scrollTop+e.currentTarget.offsetHeight)
                                    document.querySelector('.marker-popup-arrow').style.opacity = '0'
                                else
                                    document.querySelector('.marker-popup-arrow').style.opacity = '1'
                            }} itemScope={true} itemType={'https://schema.org/LocalBusiness'} className={'marker-popup-container'}>
                                <a href={e.link} className={'marker-popup-thumbnail'}>
                                    {e.sl_preview ?
                                        <img loading={'lazy'} itemProp={'image'} src={e.sl_preview.large[0]} alt={e.sl_preview.lat} />
                                        :
                                        <img itemProp={'image'} src={'https://via.placeholder.com/600/000000/f0b849?text=No+image'} alt=""/>
                                    }
                                </a>
                                <div className={'marker-popup-content'}>
                                    <span itemProp={'name'} className={'marker-popup-content-title'}>{e.title.rendered}</span>
                                    <p itemProp={'address'}>{e.sl_address}</p>
                                    <div className={'marker-popup-content-append'}>
                                        <DataHook key={`dataHook-${e.id}`} hooks={e['sl_hook'] ? e['sl_hook'] : false} position={'after_content_popup'}/>
                                    </div>
                                    <a itemProp={'url'} href={e.link}>Voir plus</a>
                                </div>
                                <div onClick={(e)=>{
                                    e.currentTarget.parentNode.scrollTo({top: e.currentTarget.parentNode.scrollHeight, behavior: 'smooth'})
                                }} className={'marker-popup-arrow'}>
                                    <Flaticon icon={"down-chevron"}/>
                                </div>
                            </div>

                        </Popup>
                    </Marker>
                        :
                        ''
                )
            })}
        </MarkerClusterGroup>

        </>
    );
}

export default StoresMarker